import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useFeatureFlags } from '../../../hooks/useFeatureFlags';
import {
  DL_SWITCH_CLASS_NAME,
  DL_SWITCH_LINE_WRAPPER_CLASS_NAME,
  GENERAL_DL_SWITCH_CLASS,
} from '../PriceViewer';

const SMASwitch: React.FC<{
  wrapAnalytics: (dataKey: string, callback: () => void) => () => void;
  show: boolean;
  intervals: number[];
  setShow: (show: boolean) => void;
  setNewIntervals: (intervals: number[]) => void;
  analyticKey: string;
}> = ({
  wrapAnalytics,
  show,
  intervals,
  setShow,
  setNewIntervals,
  analyticKey,
}) => {
  const { t } = useTranslation();

  const availableFeatures = useFeatureFlags();
  const available = availableFeatures.includes('PRICE_VIEWER_MARKET_BREADTH');

  return (
    <div className={DL_SWITCH_LINE_WRAPPER_CLASS_NAME}>
      <div
        className={classNames(GENERAL_DL_SWITCH_CLASS, {
          checked: show,
          disabled: !available,
        })}
        onClick={wrapAnalytics(analyticKey, () => setShow(!show))}
      >
        {t(analyticKey)}
      </div>

      {[50, 150, 200].map(interval => (
        <div
          key={interval}
          className={classNames(DL_SWITCH_CLASS_NAME, {
            checked: intervals.includes(interval),
            disabled: !show || !available,
          })}
          onClick={wrapAnalytics(`${analyticKey}-${interval}`, () => {
            if (!available) return;
            let newIntervals = [...intervals];
            if (intervals.includes(interval)) {
              newIntervals = newIntervals.filter(v => v !== interval);
            } else {
              newIntervals = [...newIntervals, interval];
              newIntervals.sort((a, b) => a - b);
            }
            setNewIntervals(newIntervals);
          })}
        >{`${interval}${t('d')}`}</div>
      ))}
    </div>
  );
};

export default SMASwitch;
